var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Tool from '../../common/tool';
import WmRequest from '../../common/request';
import Config from '../../common/config';
import { renderProductList } from './renderProductCard';
import { buildPlatformTabHref, buildProcenterApiPath, buildProcenterPagePath, getPlatformTabs, isAllCategory, parseProcenterRoute, } from './procenterRoute';
import { PROCENTER_DEFAULT_PLATFORM, } from './procenterTypes';
import { initProcenterDownloadButtons } from './procenterDownload';
var ProCenter = /** @class */ (function () {
    function ProCenter() {
        this.paginationInited = false;
        this.procenterDom = document.getElementById('daetool-procenter-container');
        this.routeState = parseProcenterRoute();
        this.wmRequest = new WmRequest();
        this.init();
    }
    ProCenter.prototype.init = function () {
        this.renderPlatformTabs();
        this.bindListEvents();
        this.defaultEvent();
        this.syncSidebarActive();
        this.loadProductList();
    };
    /** 侧栏一级分类：来自接口 data.filters.categories */
    ProCenter.prototype.renderSidebar = function (categories) {
        var nav = Tool.$_select(this.procenterDom, '.daetool-procenter-sidebar-nav');
        if (!nav)
            return;
        var platform = this.routeState.platformRoute || PROCENTER_DEFAULT_PLATFORM;
        var items = categories
            .map(function (cat) {
            var alias = (cat.alias || '').trim();
            if (!alias)
                return '';
            var name = cat.goods_type || alias;
            var href = "/productcenter/".concat(encodeURIComponent(alias), "/").concat(platform);
            return "<a class=\"nav-item ".concat(alias, "\" href=\"").concat(href, "\" data-alias=\"").concat(alias, "\">").concat(name, "</a>");
        })
            .join('');
        nav.innerHTML = items;
        this.syncSidebarActive();
    };
    ProCenter.prototype.syncSidebarActive = function () {
        var tabFlag = isAllCategory(this.routeState.categoryAlias)
            ? 'all'
            : this.routeState.categoryAlias.toLowerCase();
        var navItems = Tool.$_selectAll(this.procenterDom, '.daetool-procenter-container-left .nav-item');
        navItems.forEach(function (item) {
            var alias = (item.getAttribute('data-alias') || '').toLowerCase();
            item.classList.toggle('active', alias === tabFlag);
        });
    };
    ProCenter.prototype.renderPlatformTabs = function () {
        var _this = this;
        var wrap = document.querySelector('.daetool-procenter-platform-tabs');
        if (!wrap)
            return;
        var tabs = getPlatformTabs();
        var currentPlatform = this.routeState.platformRoute || PROCENTER_DEFAULT_PLATFORM;
        wrap.innerHTML = tabs
            .map(function (tab) {
            var href = buildPlatformTabHref(_this.routeState, tab.route);
            var active = tab.route === currentPlatform;
            return "<a class=\"daetool-procenter-platform-tab".concat(active ? ' is-active' : '', "\" href=\"").concat(href, "\" data-platform=\"").concat(tab.route, "\" role=\"tab\" aria-selected=\"").concat(active, "\">\n                    <span class=\"daetool-procenter-platform-tab__icon\">").concat(tab.icon, "</span>\n                    <span class=\"daetool-procenter-platform-tab__label\">").concat(tab.name, "</span>\n                </a>");
        })
            .join('');
    };
    ProCenter.prototype.bindListEvents = function () {
        var grid = Tool.$_select(this.procenterDom, '.daetool-procenter-list__grid');
        grid.addEventListener('click', function (e) {
            var target = e.target;
            var card = target.closest('.product-item');
            if (!card)
                return;
            if (target.closest('.daetool-secondary-download-outer-btn')) {
                e.stopPropagation();
                return;
            }
            if (target.closest('.daetool-procenter-learnmore-btn')) {
                e.stopPropagation();
                return;
            }
            var url = card.getAttribute('data-learnmore');
            if (url)
                window.open(url);
        });
    };
    ProCenter.prototype.setLoading = function (loading) {
        var loadingEl = Tool.$_select(this.procenterDom, '.daetool-procenter-list__loading');
        var grid = Tool.$_select(this.procenterDom, '.daetool-procenter-list__grid');
        var empty = Tool.$_select(this.procenterDom, '.daetool-procenter-list__empty');
        loadingEl.classList.toggle('show', loading);
        if (loading) {
            grid.innerHTML = '';
            empty.classList.remove('show');
        }
    };
    ProCenter.prototype.setEmpty = function (show) {
        var empty = Tool.$_select(this.procenterDom, '.daetool-procenter-list__empty');
        empty.classList.toggle('show', show);
    };
    ProCenter.prototype.loadProductList = function () {
        var that = this;
        var apiPath = buildProcenterApiPath(this.routeState);
        this.setLoading(true);
        this.wmRequest
            .ajax({
            url: apiPath,
            type: 'GET',
            data: {
                page: this.routeState.page,
                page_size: Config.PROCENTER_PAGE_SIZE,
            },
        })
            .then(function (res) {
            var _a, _b, _c;
            var body = res;
            that.setLoading(false);
            var categories = (_b = (_a = body.data) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.categories;
            if (categories === null || categories === void 0 ? void 0 : categories.length) {
                that.renderSidebar(categories);
            }
            if (body.code !== 200 || !((_c = body.data) === null || _c === void 0 ? void 0 : _c.list)) {
                that.setEmpty(true);
                return;
            }
            var list = body.data.list;
            var items = list.data || [];
            var grid = Tool.$_select(that.procenterDom, '.daetool-procenter-list__grid');
            if (!items.length) {
                grid.innerHTML = '';
                that.setEmpty(true);
            }
            else {
                that.setEmpty(false);
                grid.innerHTML = renderProductList(items, undefined, that.routeState.platformRoute);
                that.createAppQrcode();
                initProcenterDownloadButtons(grid);
            }
            that.initPagination(list.current_page, list.per_page, list.total, list.last_page);
        })
            .catch(function () {
            that.setLoading(false);
            that.setEmpty(true);
        });
    };
    ProCenter.prototype.initPagination = function (currentPage, pageSize, total, lastPage) {
        var selector = '#pagination-main';
        if (typeof DaetoolPagination === 'undefined') {
            console.warn('[procenter] daetoolPagination.js 未加载');
            return;
        }
        var that = this;
        var options = {
            element: selector,
            pageIndex: currentPage,
            pageSize: pageSize,
            pageCount: 5,
            total: total,
            layout: 'home, prev, pager, next, jumper, last',
            type: 2,
            singlePageHide: true,
            ellipsis: true,
            disabled: true,
            currentChange: function (index) {
                window.location.href = buildProcenterPagePath(__assign(__assign({}, that.routeState), { page: index }), index);
            },
        };
        if (!this.paginationInited || lastPage <= 1) {
            try {
                new DaetoolPagination(options);
                this.paginationInited = true;
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    ProCenter.prototype.defaultEvent = function () {
        var that = this;
        var leftNav = Tool.$_select(that.procenterDom, '.daetool-procenter-container-left');
        var mainRight = Tool.$_select(that.procenterDom, '.daetool-procenter-main');
        var boundaryHeight = 0;
        window.addEventListener('load', function () {
            var bodyHeight = document.body.clientHeight;
            var navHeight = leftNav.clientHeight;
            boundaryHeight = bodyHeight - 320 - navHeight;
        });
        document.addEventListener('scroll', function () {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 400 && scrollTop < boundaryHeight) {
                leftNav.style.position = 'fixed';
                leftNav.style.top = '80px';
                leftNav.style.zIndex = '99';
                var leftNavWidth = "".concat(leftNav.offsetWidth, "px");
                mainRight.style.marginLeft = leftNavWidth;
            }
            else {
                leftNav.style.position = 'static';
                mainRight.style.marginLeft = '0px';
            }
        });
    };
    ProCenter.prototype.createAppQrcode = function () {
        var appCodeListDom = this.procenterDom.querySelectorAll('.qr-code-img');
        appCodeListDom.forEach(function (el) {
            var val = el.getAttribute('data-dUrl');
            if (val && typeof createQrcode === 'function') {
                el.innerHTML = '';
                createQrcode(el, val);
            }
        });
    };
    return ProCenter;
}());
export default ProCenter;
